import { ActivatedRoute, Router } from '@angular/router';
import { LeadsService } from './../leads.service';
import { Leads } from './../leads.model';
import { Component, OnInit } from "@angular/core";
import { MetaService } from '../meta.service';
import { HelperService } from '../helper.service';
import { PicklistsService } from '../picklists.service';

@Component({
  selector: "app-gatekeeper",
  templateUrl: "./gatekeeper.component.html",
  styleUrls: ["./gatekeeper.component.css"],
})
export class GatekeeperComponent implements OnInit {
  //declare variables
  lead: Leads = new Leads();
  bRobot: boolean = false;
  strGate: string = '';
  strTitle: string = '';
  strButton: string = '';
  strReason: string = '';
  titles: any[] = [];
  industries: any[] = [];

  //inject services
  constructor(
    private ls: LeadsService,
    private router: Router, 
    private mds: MetaService,
    private hs: HelperService,
    private route: ActivatedRoute,
    private pls: PicklistsService
  ) {}

  //initialize the service
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Ready to Get Started?';
    var description = 'RegScale gatekeeper to capture user information for gated content';
    var keywords = 'RegScale, user registration, get started, demos, downloads, training, documentation';
    this.mds.updateTags(strTitle, keywords, description);

    //grab picklist data
    this.titles = this.pls.getJobTitles();
    this.industries = this.pls.getIndustries();

    //determine what to show based on route
    this.route.paramMap.subscribe(p => {
      //lead ID
      this.strGate = p.get('strGate');

      //see which gatekeeper to apply
      if (this.strGate == 'appliance') {
        this.strTitle = 'Ready to Download an ISO Virtual Appliance?';
        this.strButton = 'Download';
        this.strReason = "Appliance Download";
      } else if (this.strGate == 'download') {
        this.strTitle = 'Ready to Download RegScale?';
        this.strButton = 'Download Now';
        this.strReason = "Container Download";
      } else if (this.strGate == 'sandbox') {
        this.strTitle = "Ready to Request Your Sandbox Account?";
        this.strButton = "Request Account";
        this.strReason = "Request Sandbox Account";
      } else if (this.strGate == 'purchase') {
        this.strTitle = 'Ready to Purchase?';
        this.strButton = 'Contact Us';
        this.strReason = "Purchase";
      } else {
        console.log("ERROR: Unknown gate: " + this.strGate);
        this.router.navigate(['/notfound']);
      }
    });
  }

  //save a new contact
  save() {
    if (this.lead.email == '') {
      window.alert("You must provide a valid corporate email address to Register with RegScale.");
    } else if (this.hs.checkEmail(this.lead.email) == false) {
      this.lead.email = '';
      window.alert("You must provide a corporate email to register with RegScale.  Personal emails are not permitted.");
    } else {
      //update some of the data
      this.lead.dateSubmitted = new Date();
      this.lead.reason = this.strReason;
      this.lead.id = this.hs.createGUID();

      //save the record
      this.ls.save(this.lead);

      //clear the form
      this.lead = new Leads();
      this.bRobot = false;

      //redirect
      if (this.strGate == 'download') {
        //open the download page
        window.open("https://hub.docker.com/repository/docker/regscale/regscale", "_blank");
      }

      //navigate back to home
      this.router.navigate(['/thank-you/' + this.strGate]);
    }
  }

  //check for personal email
  checkEmail() {
    if (this.hs.checkEmail(this.lead.email) == false) {
      this.lead.email = '';
      window.alert("You must provide a corporate email to register with RegScale.  Personal emails are not permitted.");
    }
  }
  
}
